module.exports = __webpack_public_path__ + "static/media/startingmain.316dee84.jpeg";